import { ComponentProps, ForwardedRef, forwardRef } from 'react';
import styled from 'styled-components';
import { shouldIgnoreProp } from '../../utils/shouldIgnoreProp';
import { up } from '../../utils/styles/breakpoints';
import { useBodyScrollBlock } from '../../utils/useBodyScrollBlock';
import { Flex } from '../layout/Flex';
import { Backdrop } from './Backdrop';

interface DrawerProps extends ComponentProps<typeof Flex> {
    onClose: VoidFunction;
}

interface DrawerContainerProps extends ComponentProps<typeof Flex> {
    isSmartDrawer?: boolean;
}

export const DrawerContainer = styled(Flex)
    .withConfig({
        displayName: 'DrawerContainer',
        shouldForwardProp: shouldIgnoreProp('isSmartDrawer'),
    })
    .attrs((props) => ({
        direction: 'column',
        overflow: 'hidden',
        width: '100%',
        borderRadius: { sm: 3 },
        borderTopLeftRadius: 3,
        borderTopRightRadius: 3,
        maxWidth: props.maxWidth || '580px',
        ...props,
    }))<DrawerContainerProps>`
    max-height: 90dvh;
    position: ${({ isSmartDrawer }) => (isSmartDrawer ? 'relative' : 'fixed')};
    z-index: 1201;
    bottom: 0;

    ${up('md')} {
        position: relative;
        bottom: unset;
    }
`;

export const DrawerTitle = styled(Flex)
    .withConfig({ displayName: 'DrawerTitle' })
    .attrs((props) => ({
        p: 2,
        overflow: 'hidden',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        direction: 'row',
        position: 'relative',
        background: 'var(--background-primary)',
        ...props,
    }))``;

export const DrawerContent = styled(Flex)
    .withConfig({ displayName: 'DrawerContent' })
    .attrs((props) => ({
        width: '100%',
        p: { sm: 3 },
        overflowY: 'auto',
        height: 'auto',
        background: 'var(--background-primary)',
        ...props,
    }))``;

/**
 * @depricated испольуй SmartDrawer
 */
export const Drawer = forwardRef((props: DrawerProps, ref: ForwardedRef<HTMLDivElement>) => {
    const { children, ...other } = props;
    useBodyScrollBlock();

    return (
        <Backdrop onClose={props.onClose}>
            <DrawerContainer ref={ref} {...other}>
                {children}
            </DrawerContainer>
        </Backdrop>
    );
});
